var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.18 0a7 7 0 0 0-7 7c0 1.51.49 3.24 1.3 4.4l5.7 8.6 5.69-8.6a8 8 0 0 0 1.3-4.4 7 7 0 0 0-7-7Zm0 9.67A2.67 2.67 0 0 1 4.5 7a2.67 2.67 0 0 1 5.33 0c0 1.47-1.2 2.67-2.66 2.67Z"
  })));
};
export default SvgMapPin;